import { useExperimentParam } from 'src/utils/experimentNew'
import { Experiments } from '../constants'

type Variant = 'control' | 'treatment'

const EXPERIMENT_KEY = Experiments.CommentsRedesign

export function useCommentsRedesignExperiment() {
  const variant = useExperimentParam<Variant>(EXPERIMENT_KEY, 'control')

  return {
    variant,
    isTreatment: variant === 'treatment',
  }
}
